import React, { useState, useEffect } from "react";

function PreloadAnim({ getData }) {
  const [loadingComplete, setLoadingComplete] = useState(false);
}

export default PreloadAnim;

export const checkBrowser = () => {
  if (window.navigator.userAgent.includes("WebView")) return "WebView";
  else return "browser";
};
